module.exports = __webpack_public_path__ + "img/yalova-uni-logo.7c97c648.jpg";